import { LOCAL_STORAGE_KEYS } from "../constants/local-storage-keys";
import { getCountryFromDomain } from "./getCountryFromDomain";
import { getFromLocalStorage, addToLocalStorage } from "./manageLocalStorage";

const { XPENCE } = LOCAL_STORAGE_KEYS;

export const isXpenceUser = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const isXpenceFromParam = searchParams.get("xpence") === "true";
  const isXpenceFromLocalStorage = getFromLocalStorage(XPENCE);
  const isARE = getCountryFromDomain() === "ARE";

  if (isXpenceFromLocalStorage) {
    return isXpenceFromLocalStorage;
  } else if (isXpenceFromParam && isARE) {
    addToLocalStorage(XPENCE, "true");
    return true;
  } else {
    return false;
  }
}